// @flow
import { COOKIE_SET, COOKIES_LOADED } from './constants';

import { fromJS } from 'immutable';
import { handleActions } from 'redux-actions';
import handleReduce from '~/core/state/handle-reduce';

const actionHandlers = {
    // $FlowFixMe
    [COOKIES_LOADED]: handleReduce((state, { payload }) => state.merge(payload)),
    // $FlowFixMe
    [COOKIE_SET]: handleReduce((state, { payload: { key, value } }) => state.set(key, value))
};

export default handleActions(actionHandlers, fromJS({}));



// WEBPACK FOOTER //
// ./src/core/state/cookies/index.js